import { GetLoyaltyProgramsState } from './getLoyaltyPrograms.types'

const initialState: GetLoyaltyProgramsState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
